import React from "react";

const PrimaryActionButton = ({ label, onClick, type = "button" }) => (
  <button type={type} className="primary-action-btn" onClick={onClick}>
    {label}
  </button>
);

export default PrimaryActionButton;
